import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { enumHelper, statusHelper, routeHelper, storageHelper } from 'src/app/helpers';
import { eventActions, rootActions, userActions } from 'src/app/redux/actions';
import { userService } from 'src/app/services';
import { axios } from 'src/app/utils';
import { errorLocals } from 'src/locals';

function RedirectPage() {
  const { t } = useTranslation();

  const history = useHistory();
  const dispatch = useDispatch();
  const location = useLocation();
  const queryParameters = new URLSearchParams(location.search);

  const verifyToken = async (token: string, licenseId: string) => {
    axios.setToken(token);

    try {
      const { data } = await userService.getMe();

      if (!data) {
        axios.setToken(undefined);
        storageHelper.removeKeyPair('token');
        storageHelper.removeKeyPair('tokenc');
        dispatch(rootActions.resetReducerStatesToDefault());
        statusHelper.displayErrorMessage(t('errors.unknownError'));
      }

      const convertedData = enumHelper.convertUserServiceToRedux(data.user);

      dispatch(userActions.setInformation(convertedData));
      dispatch(userActions.setToken({ token: token, tokenc: data.hymotscToken }));

      axios.setToken(token);
      storageHelper.setValueWithKey('token', token);
      storageHelper.setValueWithKey('tokenc', data.hymotscToken);
    } catch (error) {
      if (error !== errorLocals.errorHandledError) {
        statusHelper.displayErrorMessage(t('errors.unknownError'));
      }
      axios.setToken(undefined);
      storageHelper.removeKeyPair('token');
      storageHelper.removeKeyPair('tokenc');
      dispatch(rootActions.resetReducerStatesToDefault());
    } finally {
      routeHelper.handleRoute(history, '/');
    }
  };

  useEffect(() => {
    const token = queryParameters.get('token');
    const licenseId = queryParameters.get('licenseId');
    const source = queryParameters.get('source');

    if (source) localStorage.setItem('source', source);

    if (token && licenseId) {
      verifyToken(token, licenseId);

      if (licenseId === '956b57c2-69de-4534-a675-dc603fc5754e') {
        dispatch(eventActions.hymotseLogin(true));
      }
    } else {
      routeHelper.handleRoute(history, '/');
    }
  }, [queryParameters.get('token'), queryParameters.get('licenseId')]);

  return null;
}

export default RedirectPage;
